/**
 * Dev environment
 *
 * Put what you like in it, but DON'T use it to build prod !
 */
export const environment = {
  production: false,
  title: 'Weezchat, tchat illimité',
  api: 'https://chat-api-new-pp.contactdve.com/api',
  chat: 'https://pp-chat-liveengine.contactdve.com/',
  extCode: 'CD',
  key: 1,
  newsSectionUrl: 'https://m.weezchat-cd.com/news',
  footerText: null,
  footerLinks: [
    { value: 'Mentions légales', href: 'http://m.weezchat-cd.com/legacy' },
    { value: 'Mon abonnement', href: 'http://www.mes-abonnements-cd.com/' }
  ],
  LP: 'http://promo.weezchat-cd.com/pwzchatcd/lp_weetic/',
  redirectIfNoIframe: null,
  useBothSignUpMethod: true,
  avatarSize: 500,
  gtm: 'GTM-5LTJH9W',
  showAllCities: true,
  completeProfileInputs: ['phoneNumber'],
  RTL: false,
  unsubscribeLink: 'http://www.mes-abonnements-cd.com/',
freeSubscription : false,
  home: {
    app: {
      available: false,
      linkGoogle: '',
      linkApple: '',
    },
    facebook: {
      available: true,
      link: 'https://www.facebook.com/WeezchatRDC/?ref=bookmarks'
    },
    twitter: {
      available: false,
      link: ''
    },
    instagram: {
      available: true,
      link: 'https://www.instagram.com/weezchat.rdc/'
    }
  },
  RGPD : {
    cookies: {
      available: true,
      link: 'https://www.dgp-legal.com/en/cookies-information/'
    }
  }
};
